import { FC, JSX, ReactNode, useEffect, useState } from "react";

// Cycles through its screens on a fixed interval. Used on the kiosk display to
// alternate between recent results and the next-challenge countdown.
const RotatingScreens: FC<{
  screens: ReactNode[];
  intervalMs?: number;
}> = ({ screens, intervalMs = 15000 }): JSX.Element | null => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (screens.length <= 1) return;

    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % screens.length);
    }, intervalMs);

    return () => clearInterval(id);
  }, [screens.length, intervalMs]);

  if (screens.length === 0) return null;

  return <>{screens[index % screens.length]}</>;
};

export default RotatingScreens;
